import React, { createContext, useContext, useEffect, useState } from "react";

// Static conversion rates from USD. Refreshed manually — art buyers understand
// FX rates are indicative, not live. Update these when you want (e.g. quarterly).
export const CURRENCIES = {
  USD: { code: "USD", symbol: "$", rate: 1, locale: "en-US" },
  EUR: { code: "EUR", symbol: "€", rate: 0.92, locale: "en-GB" },
  GBP: { code: "GBP", symbol: "£", rate: 0.78, locale: "en-GB" },
  CAD: { code: "CAD", symbol: "CA$", rate: 1.36, locale: "en-CA" },
};

const CurrencyContext = createContext({
  code: "USD",
  setCode: () => {},
  format: (n) => `$${n.toLocaleString()}`,
});

export function CurrencyProvider({ children }) {
  const [code, setCode] = useState(() => {
    try {
      const stored = localStorage.getItem("jgj_currency");
      return stored && CURRENCIES[stored] ? stored : "USD";
    } catch {
      return "USD";
    }
  });

  useEffect(() => {
    try {
      localStorage.setItem("jgj_currency", code);
    } catch {
      /* ignore storage errors */
    }
  }, [code]);

  const cfg = CURRENCIES[code];
  const format = (usd) => {
    if (usd == null) return "";
    const converted = Math.round(usd * cfg.rate);
    return `${cfg.symbol}${converted.toLocaleString(cfg.locale)}`;
  };

  return (
    <CurrencyContext.Provider value={{ code, setCode, format }}>
      {children}
    </CurrencyContext.Provider>
  );
}

export function useCurrency() {
  return useContext(CurrencyContext);
}

export function CurrencyToggle({ className = "" }) {
  const { code, setCode } = useCurrency();
  return (
    <div className={`inline-flex items-center gap-0.5 ${className}`}>
      {Object.keys(CURRENCIES).map((c) => (
        <button
          key={c}
          type="button"
          onClick={() => setCode(c)}
          className={`px-1.5 py-0.5 text-[0.65rem] tracking-[0.15em] uppercase transition-colors ${
            c === code
              ? "text-foreground border-b border-foreground"
              : "text-[hsl(var(--ink-soft))] hover:text-foreground"
          }`}
          data-testid={`currency-${c.toLowerCase()}`}
        >
          {c}
        </button>
      ))}
    </div>
  );
}
